
var PageSetup = (function() {
    var textSize = 0;
    var mapObjects = {};
    var selectedLocation = false;
    function convertPlace(addressComponents, types, formattedAddress, location) {
        var suburb = '';
        var num = '';
        var route = '';
        var addr = '';
        var state = '';
        var postcode = '';
        var country = '';
        var premise = '';
        var subpremise = '';
        var establishment = '';
        for (var i = 0; i < addressComponents.length; i++) {
            var comp = addressComponents[i];
            if (comp.types.indexOf("premise", 0) !== -1)
                premise = comp.long_name;
            else if (comp.types.indexOf("subpremise", 0) !== -1)
                subpremise = comp.long_name;
            else if (comp.types.indexOf("establishment", 0) !== -1)
                establishment = comp.long_name;
            else if (comp.types.indexOf("street_address", 0) !== -1)
                addr = comp.long_name;
            else if (comp.types.indexOf("street_number", 0) !== -1)
                num = comp.long_name;
            else if (comp.types.indexOf("route", 0) !== -1)
                route = comp.long_name;
            else if (comp.types.indexOf("locality", 0) !== -1)
                suburb = comp.long_name;
            else if (comp.types.indexOf("administrative_area_level_1", 0) !== -1)
                state = comp.short_name;
            else if (comp.types.indexOf("postal_code", 0) !== -1)
                postcode = comp.short_name;
            else if (comp.types.indexOf("country", 0) !== -1)
                country = comp.long_name;
        }
        if (addr.length === 0) {
            addr = $.trim(num + " " + route);
        }
        // Look for text like Brunswick St & McLachlan St, Fortitude Valley QLD 4006, Australia
        if (types.indexOf("intersection", 0) !== -1) {
            var ampersand = formattedAddress.indexOf("&", 0);
            var comma = formattedAddress.indexOf(",", 0);
            if (ampersand > 0 && comma > ampersand) {
                addr = "Cnr of " + $.trim(formattedAddress.substring(0, comma));
            }
        }
        if (addr.length > 0 || suburb.length > 0) {
            var result = {
                building: $.trim(subpremise + " " + premise + " " + establishment),
                address: addr,
                suburb: suburb,
                postcode: postcode,
                state: state,
                country: country,
                latLng: location
            };
            if (location) {
                result.lat = location.lat();
                result.lng = location.lng();
            }
            return result;
        }
        return null;
    }

    function InitAutocompleteSearch(inputElem, mapElem) {
        var auto = getMapObject(inputElem, "autocomplete");
        if (!auto) {
            var input = $(inputElem).get(0);
            var autocomplete = new google.maps.places.Autocomplete(input, { componentRestrictions: { country: 'au' } });
            setMapObject(inputElem, "autocomplete", autocomplete);
            google.maps.event.addListener(autocomplete, 'place_changed', function () {
                var place = autocomplete.getPlace();
                if (!place || !place.geometry) {
                    $(inputElem).data("validated-place", "").trigger("mcd:autocomplete", {});
                    return;
                }
                if (mapElem && $(mapElem).is(":visible")) {
                    var map = getMapObject(mapElem, "map");
                    if (map) {
                        google.maps.event.trigger(map, 'resize');
                        if (place.geometry.location) {
                            map.setCenter(place.geometry.location);
                            var addressMarker = getMapObject(mapElem, "autocomplete-marker");
                            if (addressMarker) {
                                addressMarker.setPosition(place.geometry.location);
                                addressMarker.setMap(map);
                            }
                        }
                        else if (place.geometry.viewport) {
                            map.fitBounds(place.geometry.viewport);
                        }
                    }
                }
                var triggerResult = { location: convertPlace(place.address_components, place.types, place.formatted_address, place.geometry && place.geometry.location), result: place };
                $(inputElem).data("validated-place", $(inputElem).val()).trigger("mcd:autocomplete", triggerResult);
                var lat = place.geometry.location.lat();
                var lng = place.geometry.location.lng();
                var address = place.formatted_address;
                var path = "/SearchRegion?lat=" + lat + "&lng=" + lng + "&address=" + address;
                $.ajax({
                    url: path,
                    type: "POST",
                    success: function (response) {
                        window.location.href = window.location.origin  + '/' + response;
                    }
                });
            });
            $(inputElem).on("mcd:blur", function () {
                var value = $(this).data("validated-place");
                if (value && value !== $(this).val()) {
                    $(this).data("validated-place", "").trigger("mcd:autocomplete", {});
                }
            });
        }
    }

    var listElement = document.getElementById("suggestionList");
    var currentFocus = -1;

    function addFocus(element) {
        if (!element) return;
        element.classList.add("focus-active")
        element.children[0].style.backgroundPosition = "-18px -161px"
        setAddressToInputField(element.lastElementChild.textContent)
    }

    function removeFocus(element) {
        element.classList.remove("focus-active")
        element.children[0].style.backgroundPosition = "-1px -161px"
    }

    function setAddressToInputField(address) {
        var input = document.getElementById("SearchCriteria_WhereText");
        input.value = address;
    }

    function removeElements(elementId) {
        var element = document.getElementById(elementId);

        if (element) {
            element.style.display = 'none';

            var child = element.lastElementChild;
            while (child) {
                element.removeChild(child);
                child = element.lastElementChild;
            }
        }
    }

    function setAddressToInputFieldWithStyle(item) {
        var input = document.getElementById("SearchCriteria_WhereText");
        input.value = item.DisplayName;
        var icon = document.getElementById("txt-location-input-icon");
        if (icon) {
            if (item.LocationType.toUpperCase() == "LGA") {
                icon.style.backgroundImage = "url('/_static/static-page-assets/images/icons/lga_icons.png')";
            }
            else {
                icon.style.backgroundImage = "url('/_static/static-page-assets/images/icons/pin_icons.png')";
            }
        }
    }

    function addElements(arr, elementId, isRedirecting) {
        var element = document.getElementById(elementId);
        if (!element) return; // Early exit if element is not found

        element.style.display = 'block'; // Make the container visible

        if (arr.length > 1) {
            arr.forEach(function (item) {
                var li = document.createElement("li");
                var div = document.createElement("div");

                // Make the matching letters bold:
                var inputValLength = document.getElementById("SearchCriteria_WhereText").value.length;
                var name = "<strong>" + item.DisplayName.substr(0, inputValLength) + "</strong>";
                name += item.DisplayName.substr(inputValLength);

                var icon = document.createElement("div");
                li.classList.add("suggestions-item");
                li.style.padding = "0 4px";
                div.classList.add("suggestion-title");
                div.innerHTML = name;

                li.appendChild(icon);
                li.appendChild(div);
                element.appendChild(li);

                icon.classList.add("suggestion-icon");
                if (item.LocationType.toUpperCase() === "LGA") {
                    icon.style.backgroundImage = "url('/_static/static-page-assets/images/icons/lga_icons.png')";
                } else {
                    icon.style.backgroundImage = "url('/_static/static-page-assets/images/icons/pin_icons.png')";
                }

                li.addEventListener("click", function () {
                    setAddressToInputFieldWithStyle(item);
                    //storeSeletedAddressObj(item);
                    removeElements(elementId);

                    //document.getElementById("hfCouncilId").value = item.CouncilID;
                    //document.getElementById("hfLocationId").value = item.LocationID;

                    if (window.location.pathname !== "/Search/Directory") {
                        if (isRedirecting) {
                            var whatText = $('#SearchCriteria_WhatText').val().replace(/[,\s]+/g, "_");
                            var whereText = $('#SearchCriteria_WhereText').val().replace(/[,\s]+/g, "_");
                            var path = "/StoreSearchedModelInSession";
                            $.ajax({
                                url: path,
                                data: JSON.stringify({
                                    DisplayName: item.DisplayName,
                                    Url: item.Url,
                                    LocationType: item.LocationType,
                                    Lat: item.Lat,
                                    Lng: item.Lng,
                                    CouncilID: item.CouncilID,
                                    LocationID: item.LocationID
                                }),
                                contentType: "application/json",
                                type: "POST",
                                success: function (response) {
                                    if (response && response.length > 0) {
                                        var path = window.location.origin;
                                        if (response[0] !== '/') {
                                            path += '/';
                                        }
                                        path += response;
                                        var params = [];
                                        // Check if 'whatText' is not empty and add to parameters
                                        if (whatText.trim() !== "") {
                                            params.push("what=" + encodeURIComponent(whatText));
                                        }
                                        // Check if 'whereText' is not empty and add to parameters
                                        if (whereText.trim() !== "") {
                                            params.push("where=" + encodeURIComponent(whereText));
                                        }
                                        // Join parameters with '&' and append to the base URL
                                        if (params.length > 0) {
                                            path += "?" + params.join("&");
                                        }
                                        window.location.href = path;
                                    }
                                },
                                error: function (err) {
                                    console.error(err);
                                },
                            });
                        }
                    }
                });
            });
        }
    }

    function InitAutocompleteSearchCouncil(inputElem, mapElem) {
        var whereText;
        var whatText;

        var isRedirecting = true;

        var $locationInput = $(inputElem);
        $locationInput.on("input", function (event) {
            event.preventDefault();
            event.stopImmediatePropagation();
            var input = $(this).val();
            if (input.length >= 3) {
                var xhttp = new XMLHttpRequest();
                xhttp.onreadystatechange = function () {
                    if (this.readyState == 4 && this.status == 200) {
                        var data = JSON.parse(this.responseText)
                        removeElements("suggestionList");
                        addElements(data, "suggestionList", isRedirecting);
                    }
                };

                xhttp.open("GET", window.AppSettings.ApiUrl + "/api/v1/system/councils/searchall/" + input, true);
                xhttp.send();
            }
        });

        // Remove suggestion list when user click somewhere else that is not one of the suggestion items
        // and reset the location text
        $(window).click(function (event) {
            var target = $(event.target);
            if (!target.is(".suggestions-item")) {
                if (!selectedLocation) {
                    removeElements("suggestionList");
                    setDefaultLocation(false, false);
                }
            }
        });

        $locationInput.on("click keydown", function (e) {

            var x;
            if (listElement) x = listElement.children;

            /*If the arrow DOWN key is pressed, focus on the elemen*/
            if (e.which == 40) {
                currentFocus++;
                addFocus(x[currentFocus])
                if (x[currentFocus - 1])
                    removeFocus(x[currentFocus - 1])
                if (currentFocus >= listElement.children.length) {
                    currentFocus = 0;
                    addFocus(x[currentFocus])
                }
            }
            /*If the arrow UP key is pressed, focus on the elemen:*/
            else if (e.which == 38) {
                currentFocus--;
                addFocus(x[currentFocus])
                if (x[currentFocus + 1])
                    removeFocus(x[currentFocus + 1])
                if (currentFocus <= -1) {
                    currentFocus = listElement.children.length - 1;
                    addFocus(x[currentFocus])
                }
            }
            /*If the ESC key is pressed, close the list*/
            else if (e.which == 27) {
                removeElements("suggestionList");
                setDefaultLocation(false, false);
            }
            /*If the ENTER key is pressed, prevent the form from being submitted,*/
            else if (e.which == 13) {
                e.preventDefault();
                if (currentFocus > -1) {
                    /*and simulate a click on the "active" item:*/
                    if (listElement) {
                        x[currentFocus].click();
                        currentFocus = -1;
                    }
                }
            }
        });
    }

    function getMapObject(elem, type) {
        var id = $(elem).attr("id");
        if (id) {
            return mapObjects[id + "/" + type];
        }
        return undefined;
    }
    function setMapObject(elem, type, obj) {
        var id = $(elem).attr("id");
        if (id) {
            mapObjects[id + "/" + type] = obj;
        }
    }
    function hidebanner() {
        $("#virus-banner").slideUp('slow');
        $("#virus-banner").hide();
    }

    function showSpinner(item) {
        $(item).addClass("spinner");
    }

    function removeSpinner(item) {
        $(item).removeClass("spinner");
    }

    function setCookie(cname, cvalue, exdays) {
        var d = new Date();
        d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
        var expires = "expires=" + d.toUTCString();
        document.cookie = cname + "=" + cvalue + "; " + expires + "; secure=true";
    }

    function getCookie(cname) {
        var name = cname + "=";
        var ca = document.cookie.split(';');
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ') c = c.substring(1);
            if (c.indexOf(name) === 0) return c.substring(name.length, c.length);
        }
        return "";
    }

    function handleNoGeolocation(errorMsg) {
        $("#foundCouncil .btn-link").off("click");
        $("#foundCouncil .btn-link").on("click", function () {
            $("#foundCouncil").slideUp('slow');
        });

        $("#foundCouncil .location-error").show();
        $("#foundCouncil .location-error .message-text").html(errorMsg);
        $("#foundCouncil .location-success").hide();
        $("#foundCouncil").slideDown('slow');
    }

    function isValidPassword(password) {
        var isValid = true;

        // password bigger than 6 
        if (password.length > 6) {
            $("li.six-plus").addClass("complete");
        } else {
            $("li.six-plus").removeClass("complete");
            isValid = false;
        }

        if (password.match(/[a-z]/)) {
            $("li.lcase").addClass("complete");
        } else {
            $("li.lcase").removeClass("complete");
            isValid = false;
        }

        if (password.match(/[A-Z]/)) {
            $("li.ucase").addClass("complete");
        } else {
            $("li.ucase").removeClass("complete");
            isValid = false;
        }

        //if password has at least one number give 1 point
        if (password.match(/\d+/)) {
            $("li.numbers").addClass("complete");
        } else {
            $("li.numbers").removeClass("complete");
            isValid = false;
        }

        if (password.indexOf(' ') == -1) {
            $("li.nospaces").addClass("complete");
        } else {
            $("li.nospaces").removeClass("complete");
            isValid = false;
        }

        //if password has at least one special caracther give 1 point
        if (password.match(/.[!,@,#,$,%,^,&,*,=,?,_,~,-,.,(,)]/)) {
            $("li.punctuation").addClass("complete");
        } else {
            $("li.punctuation").removeClass("complete");
            isValid = false;
        }

        return isValid;
    }

    window.setupTooltipsStyling = function () {
        $(document).on('mouseover', '[title]', function (e) {
            //$(this).qtip({
            //    overwrite: false,
            //    content: $(this).attr('title'),
            //    show: {
            //        event: e.type,
            //        ready: true
            //    },
            //    position: {
            //        my: "bottom right",
            //        at: "top right"
            //    },
            //    style: {
            //        classes: 'qtip-dark qtip-shadow qtip-rounded'
            //    },
            //    events: {
            //        show: function (event, api) {
            //            var $el = $(api.elements.target[0]);
            //            $el.qtip('option', 'position.my', ($el.data('tooltip-my') === undefined) ? 'bottom right' : $el.data('tooltip-my'));
            //            $el.qtip('option', 'position.at', ($el.data('tooltip-at') === undefined) ? 'top right' : $el.data('tooltip-at'));
            //        }
            //    }
            //}, e);
            $(this).attr('oldtitle', $(this).attr('title'));
            $(this).removeAttr('title');
        });
    };

    function setupLocationNag() {
        if ($("#popupModal").length) {
            $("#popupModal").on("hidden.bs.modal", function () {
                RequestLocation();
            });
        }
        else {
            RequestLocation();
        }
    }

    function RequestLocation(destUrl, locationPrefix, wherePrefix, locationId, locationName) {
        var location = {};
        location.DestinationUrl = destUrl;
        location.LocationUrlPrefix = locationPrefix;
        location.WhereUrlPrefix = wherePrefix;
        location.Council = null;
        location.ID = locationId;
        location.Name = locationName;

        if (location.ID > 0 || location.Name) {
            // Pass through here when the user clicked on the Search button and has supplied a location
            gotoLocation(location);
            return;
        }

        setPanelContents("None", location);

        var offerHelp = getCookie("Mcdiary.LocationNag");
        if (offerHelp === "Declined") {
            // Pass through here when the user has said No Thanks
            if (location.DestinationUrl && location.DestinationUrl !== "") {
                window.location.href = location.DestinationUrl;
            }
            hideLocationPanel();
            return;
        }

        location = GetLocationCookie(location);
        if (location.Council != null) {
            // Show the user where we think they previously searched
            setPanelContents("Previous", location);
        }
        else {
            RequestBrowserLocation(location);
        }

        showLocationPanel();

        $("#btn-no-thanks").off("click").on("click", function (e) {
            e.preventDefault();
            setCookie("Mcdiary.LocationNag", "Declined");
            if (location && location.DestinationUrl && location.DestinationUrl !== "") {
                window.location.href = location.DestinationUrl;
            }
            hideLocationPanel();
        });

        // When a location is selected from autocomplete, adjust council properties and update cookie
        $("#location-request").on("typeahead:selected", function (obj, datum) {
            $.getJSON(window.AppSettings.ApiUrl + "/api/v1/system/localities/id/" + datum.LocalityID,
                function (data) {
                    if (data) {
                        location.ID = datum.LocalityID;
                        location.Name = data.Name + " " + data.Postcode;
                        location.Council = {
                            CouncilRegionID: data.CouncilRegionID,
                            DisplayName: data.CouncilDisplayName,
                            Url: data.CouncilURL
                        };

                        SetLocationCookie(location);
                    } else {
                        Alert("<p>We were unable to successfully determine the location you wish to search in. Please be more specific with your location or select an item from the list.</p>", "");
                    }
                }
            );
        });
    }

    function Alert(text, title, okCallback, okLabel) {
        title = title || "Alert";
        okLabel = okLabel || "OK";
        var id = 'autoAlertModal';
        $("body").remove("#" + id);
        var modal = $('\
                <div id=' + id + ' class="modal fade" tabindex="-1" role="dialog"> \
                    <div class="modal-dialog" role="document"> \
                        <div class="modal-content"> \
                            <form method="post" action=""> \
                                <div class="modal-header"> \
                                    <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button> \
                                    <h4 class="modal-title">' + title + '</h4> \
                                </div> \
                                <div class="modal-body">' + text + '</div> \
                                <div class="modal-footer"> \
                                    <button type="button" class="btn btn-default modal-ok" data-dismiss="modal">' + okLabel + '</button> \
                                </div> \
                            </form> \
                        </div> \
                    </div> \
                </div>');

        var hadAction = false;

        modal.on("click", ".modal-ok", function (e) {
            e.preventDefault();
            hadAction = true;
            if (okCallback) okCallback();
        });

        modal.on('hidden.bs.modal', function () {
            modal.remove();

            if (!hadAction) {
                hadAction = true;
                if (okCallback) okCallback();
            }
        });

        modal.modal('show');
    }

    function gotoLocation(location) {
        if (location.ID && location.ID !== 0) {
            if (!location.Name) {
                $.getJSON(window.AppSettings.ApiUrl + "/api/v1/system/localities/id/" + location.ID,
                    function (data) {
                        if (data) {
                            location.Name = data.Name + " " + data.Postcode;
                            location.Council = {
                                CouncilRegionID: data.CouncilRegionID,
                                DisplayName: data.CouncilDisplayName,
                                Url: data.CouncilURL
                            };
                            checkCouncilandProceed(location);
                        } else {
                            Alert("<p>We were unable to successfully determine the location you wish to search in. Please be more specific with your location or select an item from the list.</p>", "");
                        }
                    }
                );
            } else {
                checkCouncilandProceed(location);
            }
        } else {
            if (location.Name) {
                $.ajax({
                    type: "POST",
                    url: window.AppSettings.ApiUrl + "/api/v1/system/localities/search",
                    data: JSON.stringify({ SearchTerm: location.Name }),
                    contentType: "application/json; charset=utf-8",
                    dataType: "json",
                    success: function (data) {
                        if (data) {
                            location.ID = data.LocalityID;
                            location.Name = data.Name + " " + data.Postcode;
                            location.Council = {
                                CouncilRegionID: data.CouncilRegionID,
                                DisplayName: data.CouncilDisplayName,
                                Url: data.CouncilURL
                            };
                            checkCouncilandProceed(location);
                        } else {
                            Alert("<p>We were unable to successfully determine the location you wish to search in. Please be more specific with your location or select an item from the list.</p>", "");
                        }
                    }
                });
            } else {
                Alert("<p>The directory works best when we have a location to search in. Please specify a location.</p>", "");
            }
        }
    }

    function checkCouncilandProceed(location) {
        if (!location.Council || location.Council.CouncilRegionID == 0) {
            $.getJSON(window.AppSettings.ApiUrl + "/api/v1/system/councils/locality/" + location.ID,
                function (data) {
                    if (data && data.Loaded) {
                        location.Council = data;
                        location.DestinationUrl = location.DestinationUrl || data.Url;
                        SetLocationCookie(location);
                        window.location.href = location.DestinationUrl;
                    } else {
                        Alert("<p>We were unable to successfully determine the location you wish to search in. Please be more specific with your location or select an item from the list.</p>", "");
                    }
                }
            );
            return;
        }
        location.DestinationUrl = location.DestinationUrl || location.Council.Url;
        SetLocationCookie(location);
        window.location.href = location.DestinationUrl;
    }

    function showLocationPanel() {
        $("#location-request-blind").show();
        $("#location-request-panel").slideDown("slow", function () { $("#location-request").focus() });
    }

    function hideLocationPanel() {
        $("#location-request-panel").slideUp("slow");
        $("#location-request-blind").hide();
    }

    function RequestBrowserLocation(location) {
        if (window.navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(function (position) {
                findCouncilandLocation(position, location);
            }, function (error) {
                console.log("Geolocation Error: ", error)
            }, { enableHighAccuracy: true });
        }
    }
    
    function SetLocationCookie(location) {
        setCookie("Mcdiary.Location", "Council:" + JSON.stringify(location.Council) + "|ID:" + location.ID + "|Name:" + location.Name, 365);
    }

    function GetLocationCookie(location) {
        var cookie = getCookie("Mcdiary.Location");
        var valid = true;
        var council, id, name;
        if (cookie) {
            var parts = cookie.split('|');
            for (var i = 0; i < parts.length; i++) {
                if (parts[i].substr(0, 8) === "Council:") {
                    try {
                        council = JSON.parse(parts[i].substr(8));
                        if ($.isEmptyObject(council)) {
                            valid = false;
                        }
                    } catch (e) {
                        valid = false;
                    }
                } else if (parts[i].substr(0, 3) === "ID:") {
                    id = parseInt(parts[i].substr(3));
                    if (isNaN(parseInt(id))) {
                        valid = false;
                    }
                } else if (parts[i].substr(0, 5) === "Name:") {
                    name = parts[i].substr(5);
                }
            }

            if (valid && typeof council !== "undefined" && typeof id !== "undefined" && typeof name !== "undefined") {
                location.Council = council;
                location.ID = id;
                location.Name = name;
            }
            else {
                setCookie("Mcdiary.Location", {}, -1);
            }
        }

        return location;
    }

    function setPanelContents(content, location) {

        $(".locality-id").val(location.ID);
        $("#location-request").typeahead("val", location.Name);

        switch (content) {
            case "None":
                $("#location-request-panel .inner .blurb").html("<p>Want better results? <br /><strong>Tell us your location to refine your search</strong> <br />to help us find listings near you?</p>");
                break;

            case "Previous":
                $("#location-request-panel .inner .blurb").html("<p>Previously you searched near <span>" + location.Name + "</span><br /><strong>Would you like to refine your search</strong><br />to listings in <span>" + location.Council.DisplayName + "</span>?</p>");
                break;

            case "Located":
                $("#location-request-panel .inner .blurb").html("<p>It looks like you're near <span>" + location.Name + "</span><br /><strong>Would you like to refine your search</strong><br />to listings in <span>" + location.Council.DisplayName + "</span>?</p>");
                break;
        }

        $("#btn-go-location").off("click").on("click", function (e) {
            e.preventDefault();
            location.ID = parseInt($("#hfLocationRequestId").val());
            location.Name = $("#location-request").val();

            if (location.Name === "") {
                Alert("<p>The directory works best when we have a location to search in. Please specify a location.</p>", "");
                return;
            }

            gotoLocation(location);
        });
    }

    function findCouncilLocation(position) {
        var address = $("#autocomplete-location-new").val();
        var path = "/SearchRegion?lat=" + position.coords.latitude + "&lng=" + position.coords.longitude + "&address=" + address;

        $.ajax({
            url: path,
            type: "POST",
            success: function (response) {
                window.location.href = window.location.origin + '/' + response;
            }
        });
    }

    function findCouncilandLocationNewHome(position) {
        var geocoder = new google.maps.Geocoder();
        var latlng = {
            lat: parseFloat(position.coords.latitude),
            lng: parseFloat(position.coords.longitude),
        };
        geocoder.geocode({ location: latlng }, function (results, status) {
            if (status === "OK") {
                if (results[0]) {
                    $(".autocomplete").val(results[0].formatted_address);
                }
                else {
                    window.alert("No results found");
                }
            }
            else {
                window.alert("Geocoder failed due to: " + status);
            }
        });
    }

    function findCouncilandLocation(position, location) {
        var siteParam = "";
        if (window.AppSettings.AffiliateSiteID) {
            siteParam = "?site=" + window.AppSettings.AffiliateSiteID;
        }

        $.getJSON(window.AppSettings.ApiUrl + "/api/v1/system/councils/" + position.coords.latitude + "/" + position.coords.longitude + siteParam,
            function (data) {
                if (data.CouncilRegionID && data.CouncilRegionID > 0) {
                    location.Council = data;
                    findLocation(position, location);
                }
            }
        );
    }

    function findLocation(position, location) {
        $.getJSON(window.AppSettings.ApiUrl + "/api/v1/system/localities/" + position.coords.latitude + "/" + position.coords.longitude,
            function (data) {
                if ((data.LocalityID || 0) > 0 || (data.Name || "") !== "") {
                    location.ID = data.LocalityID;
                    location.Name = data.Name;
                    setPanelContents("Located", location);
                }
            }
        );
    }

    function locationTypeahead(fieldName, locations) {
        $(fieldName).typeahead({
            hint: true,
            minLength: 2,
            highlight: true
        }, {
            name: "locations",
            displayKey: "Name",
            source: locations.ttAdapter(),
            templates: {
                suggestion: function (d) {
                    return "<p class='needsclick'>" + d.Name + "</p>";
                }
            }
        });
        $(fieldName)
            .on("typeahead:selected", function (obj, datum) {
                $(".locality-id", $(this).closest(".twitter-typeahead").parent()).val(datum.LocalityID);
            }).on("typeahead:autocompleted", function (obj, datum) {
                $(".locality-id", $(this).closest(".twitter-typeahead").parent()).val(datum.LocalityID);
            }).on("typeahead:asyncrequest", function () {
                $(".locality-id", $(this).closest(".twitter-typeahead").parent()).val(0);
                $(this).addClass("spinner");
            }).on("typeahead:startupdate", function () {
                $(".locality-id", $(this).closest(".twitter-typeahead").parent()).val(0);
                $(this).addClass("spinner");
            }).on("typeahead:datasetupdated", function () {
                $(this).removeClass("spinner");
                if (!$(this).val().length) {
                    $(".locality-id", $(this).closest(".twitter-typeahead").parent()).val(0);
                }
            });
    }

    return {
        InitPage: function () {
            _this = this;

            $.ajaxSetup({
                headers: { 'Authorization': "Basic " + window.AppSettings.ApiToken }
            });

            // Placeholder support for IE
            $('input').placeholder();

            var previouslyFocused;
            $(".modal").on("show.bs.modal", function () {
                previouslyFocused = document.activeElement;
            });

            $(".modal").on("shown.bs.modal", function () {
                // Make first input field in a modal get focus
                var $field = $("input[type=text],textarea,select", this).filter(":visible:enabled:not([readonly]):first");
                if ($field != null) {
                    $field.focus();
                }

                $(this).attr("aria-hidden", "false");

                // Handle behaviour when user _could_ be tabbing out of modal... confusing for screen reader users
                var $inputs = $("select, input, textarea, button, a, [tabinput='0']", this).filter(":visible:not([disabled]):not([readonly])");
                var $firstInput = $inputs.first();
                var $lastInput = $inputs.last();

                $lastInput.on("keydown", function (e) {
                    if (e.which === 9 && !e.shiftKey) {
                        e.preventDefault();
                        $firstInput.focus();
                    }
                });

                $firstInput.on("keydown", function (e) {
                    if (e.which === 9 && e.shiftKey) {
                        e.preventDefault();
                        $lastInput.focus();
                    }
                });
            });

            $(".modal").on("hidden.bs.modal", function () {
                $(this).attr("aria-hidden", "true");

                // Restore focus to previous element
                if (previouslyFocused) {
                    $(previouslyFocused).focus();
                }
            });
            $("#btn-cross").off("click").on("click", function (e) {
                e.preventDefault();
                
                hidebanner();
            });

            // Initialise apsects of the page
            _this.InitTooltips();
            _this.InitSearchButton();
            _this.InitNavigation();
            _this.InitSliders();
            _this.InitPullout();
            _this.InitTextSizeChange();

            _this.ObfuscateEmails();
            _this.InitMap();

            _this.InitAutoComplete();
            _this.InitCouncilSearch();

            // Tooltips for all elements with a non-empty title attribute
            setupTooltipsStyling();
        },

        ConfigureSettings: function (settings) {
            window.AppSettings = settings;
        },

        InitValidation: function () {
            $.validator.setDefaults({
                errorClass: "has-error",
                validClass: "has-success",
                highlight: function (element, errorClass, validClass) {

                    if (element.type === "radio") {
                        this.findByName(element.name).addClass(errorClass).removeClass(validClass);
                    } else {
                        $(element).closest('.form-row').removeClass(validClass).addClass(errorClass);
                        $(element).closest('.form-row').find('i.glyphicon.form-control-feedback').remove();
                        $(element).closest('.form-row').append('<i class="glyphicon glyphicon-remove form-control-feedback"></i>');
                    }
                },
                unhighlight: function (element, errorClass, validClass) {
                    if (element.type === "radio") {
                        this.findByName(element.name).removeClass(errorClass).addClass(validClass);
                    } else {
                        $(element).closest('.form-row').removeClass(errorClass).addClass(validClass);
                        $(element).closest('.form-row').find('i.glyphicon.form-control-feedback').remove();
                        $(element).closest('.form-row').append('<i class="glyphicon glyphicon-ok form-control-feedback"></i>');
                    }
                }
            });

            $.validator.addMethod(
                "usernameAvailable",
                function (value, element) {
                    var checkUrl = "/api/Users/IsUsernameAvailable";
                    return $.validator.methods.remote.call(this, value, element, { url: checkUrl });
                }, "User name not available"
            );

            $.validator.addMethod(
                "mobileAvailable",
                function (value, element) {
                    var checkUrl = "/api/Users/IsMobileAvailable";
                    return $.validator.methods.remote.call(this, value, element, { url: checkUrl });
                }, "That Mobile number is already in use"
            );

            $.validator.addMethod(
                "emailAvailable",
                function (value, element) {
                    var checkUrl = "/api/Users/IsEmailAvailable";
                    return $.validator.methods.remote.call(this, value, element, { url: checkUrl });
                }, "Email address already in use"
            );

            $.validator.addMethod(
                "mcdUsername",
                function (value, element) {
                    var re = new RegExp(/^[A-Za-z0-9_@\.]{5,}$/);
                    return this.optional(element) || value.match(re);
                },
                "Please enter a valid username."
            );

            $.validator.addMethod("ausPhone", function (value, element) {
                var re = new RegExp(/^04\d{8}\s*$|^(04\d{2}\s\d{3}\s\d{3})\s*$|^(\d{2}\s*\d{4}\s*\d{4})\s*$|^(\(*\d{2}\)\s*\d{4}\s*\d{4})\s*$|^13(\s*\d{2}){2,3}$|^(1300|1800)\s*\d{3}\s*\d{3}\s*$/);
                return this.optional(element) || value.match(re);
            }, "Please enter a valid Australian phone number.");

            $.validator.addMethod("ausMobile", function (value, element) {
                var trimmedValue = value.replace(/[^\d\+]/gi, '');
                var re = new RegExp(/^\({0,1}((0|\+61)(4)){0,1}\){0,1}(\ |-){0,1}[0-9]{2}(\ |-){0,1}[0-9]{2}(\ |-){0,1}[0-9]{1}(\ |-){0,1}[0-9]{3}$/);
                return this.optional(element) || trimmedValue.match(re);
            }, "Please enter a valid Australian mobile number.");

            $.validator.addMethod("ausDate", function (value, element) {
                return Date.parseExact(value, "d/M/yyyy");
            }, "Please enter a value date. eg. d/M/yyyy");

            $.validator.addMethod("regex", function (value, element, regexp) {
                var re = new RegExp(regexp);
                return this.optional(element) || value.match(re);
            }, "Please check your input.");

            $.validator.addMethod("simpleUrl", function (value, element) {
                // Customised version of the url test to make the prefix optional
                return this.optional(element) || /^((https?|ftp):\/\/)?(((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:)*@)?(((\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5]))|((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?)(:\d*)?)(\/((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)+(\/(([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)*)*)?)?(\?((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|[\uE000-\uF8FF]|\/|\?)*)?(\#((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|\/|\?)*)?$/i.test(value);
            }, "Please enter a valid URL.");

            $(".ausMobile").on("blur", function () {
                var mobileRe = new RegExp(/^04\d{8}$/);
                var trimValue = $(this).val();

                trimValue = trimValue.replace(/[^\d\+]/gi, '');

                if (trimValue.startsWith("+61")) {
                    trimValue = trimValue.replace("+61", "0");
                }

                if (trimValue.match(mobileRe)) {
                    newValue = trimValue.substr(0, 4) + " " + trimValue.substr(4, 3) + " " + trimValue.substr(7, 3);
                    $(this).val(newValue);
                }
            });

        },

        InitTooltips: function () {
            // Create tooltips
            $('[data-toggle="tooltip"]').each(function () {
                $(this).tooltip({
                    trigger: "hover focus"
                });
                $(this).on("click touchend", function (e) {
                    e.preventDefault();
                });
            });
        },

        InitSearchButton: function () {
            $("#hfLocationId").val(arguments[0] || 0);
            $('#autocomplete-location').val(arguments[1] || '');
            //if (document.getElementById('autocomplete-location-new')) {
            //    InitAutocompleteSearch('#autocomplete-location-new');
            //}
            if (document.getElementById('SearchCriteria_WhereText')) {
                InitAutocompleteSearchCouncil('#SearchCriteria_WhereText')
            }
            $("#btn-search").off('click touchend');
            $("#btn-search").on('click touchend', function (e) {
                e.preventDefault();
                var categoryId = $("#hfCategoryId").val() || 0;
                var serviceId = $("#hfServiceId").val() || 0;
                var locationId = $("#hfLocationId").val() || 0;
                var rad = $(".ddl-radius").val() || 50;
                var txt = $('#autocomplete-category').val();
                var where = $('#autocomplete-location').val();
                var councilId = $("#hfCouncilId").val() || 0;
                if ($('#autocomplete-location-new').val() == "") {
                    state = "";
                }

                var url = '/Search/Directory?what=' + encodeURIComponent(txt) +
                    '&where=' + encodeURIComponent(where) +
                    '&service=' + serviceId +
                    '&category=' + categoryId +
                    '&location=' + locationId +
                    '&radius=' + rad +
                    '&council=' + councilId;

                window.location = url;
            });

            $(".advanced-search-btn").on('click touchend', function (e) {
                e.preventDefault();
                var categoryId = $("#hfCategoryId").val() || 0;
                var serviceId = $("#hfServiceId").val() || 0;
                var locationId = $("#hfLocationId").val() || 0;
                var rad = $(".ddl-radius").val() || 50;
                var txt = $('#autocomplete-category').val() || "";
                var where = $('#autocomplete-location').val() || "";
                var councilId = $("#hfCouncilId").val() || 0;

                var tempUrl = '/Search/Advanced' + location.search;
                
                window.location = tempUrl;
            });
        },

        IsValidPassword: function (password) {
            return isValidPassword(password);
        },

        InitNavigation: function () {
            // Bind toggle events for navigation pullouts
            $(".menu-button").on("click touchend", function () {
                $(".wrapper:eq(0)").toggleClass("reveal-right");
                document.activeElement.blur();
                return false;
            });

            // Close the navigation pullouts under certain conditions
            // Track when the touch move event is detected
            var touchMoved = false;
            $(document).on("touchmove", function (e) {
                touchMoved = true;
            });
            $(document).on("click touchend", function (e) {
                // If the touchend event is detected, but the touchmoved flag is true, then don't try to close the menus
                // This is to allow users to scroll down the browser in order to navigate a long menu, without it unexpectedly closing the menu
                if (e.type == "touchend" && touchMoved)
                    return;

                // Close by default
                var closePullouts = true;

                // Except when a touch or click is detected in the nav panels
                if ($(e.target).hasClass("mobile-menu") || $(e.target).parents(".mobile-menu").length > 0)
                    closePullouts = false;

                if (closePullouts) {
                    $(".wrapper").removeClass("reveal-right");
                }
            });
        },

        GeolocateCouncil: function () {
            if (window.navigator.geolocation) {
                navigator.geolocation.getCurrentPosition(findCouncilandLocationNewHome, function (posError) {
                    handleNoGeolocation("We were unable to get your location from your browser for the following reason: <em>" + posError.message + "</em>");
                });
            } else {
                handleNoGeolocation("Your browser was unable to provide us with your location details.");
            }
        },

        InitSliders: function () {
            // Initialise any sliders with the 'slickify' class using its defined settings
            $('.slickify').each(function () {
                $(this).slick({
                    slidesToShow: $(this).attr("data-slick-slidesToShow"),
                    slide: $(this).attr("data-slick-slideElement"),
                    autoplay: $(this).attr("data-slick-autoplay") == "true",
                    autoplaySpeed: $(this).attr("data-slick-autoplaySpeed")
                });
            });
        },

        InitPullout: function () {
            // Behaviour for the search panel pullout
            $(".pullout-button").on("click touchend", function (e) {
                e.preventDefault();
                $(this).next(".pullout-content").toggleClass("pullout-content-shown");
                $(this).toggleClass("pullout-button-active");

                var shown = $(this).next(".pullout-content").is(".pullout-content-shown");

                $(this).next(".pullout-content").attr("tabindex", shown ? "0" : "-1");
                $("#btnSupportModal").attr("tabindex", shown ? "0" : "-1");
            });

            $("#btnSupportModal").off("click touchend").on("click touched", function(e) {
                $("#supportModal").modal();
                $("#website-help .pullout-content").removeClass("pullout-content-shown");
                $("#website-help .pullout-button").removeClass("pullout-button-active");
            });
        },

        InitTextSizeChange: function () {
            var ModuleReference = this;
            $(".text-larger").on("click touchend", function (e) {
                e.preventDefault();
                var increment = 10;
                ModuleReference.ChangeTextSize(increment);
            });
            $(".text-smaller").on("click touchend", function (e) {
                e.preventDefault();
                var increment = -10;
                ModuleReference.ChangeTextSize(increment);
            });
            $(".textSizeIndicator").on("click touchend", function (e) {
                e.preventDefault();
                ModuleReference.ResetTextSize();
            }).on("mouseover", function (e) {
                e.preventDefault();
                $(".textSizeIndicator").text('Reset');
            }).on("mouseout", function (e) {
                e.preventDefault();
                if (textSize === 0) textSize = 100;
                $(".textSizeIndicator").text(textSize + '%');
            });
            if (typeof (Storage) !== "undefined") {
                // Check for previous changes to text size
                var incrementCount = parseInt(localStorage.getItem("incrementCount")) || 0;
                var i;

                if (incrementCount > 0) {
                    // Increase font size until it matches previous setting
                    for (i = 0; i < incrementCount; i++) {
                        ModuleReference.ChangeTextSize(10);
                    }
                }
                else if (incrementCount < 0) {
                    // Decrease font size until it matches previous setting
                    for (i = 0; i > incrementCount; i--) {
                        ModuleReference.ChangeTextSize(-10);
                    }
                }
            }
        },

        ResetTextSize: function () {
            if (typeof (Storage) !== "undefined") {
                localStorage.setItem("incrementCount", 0);
            }
            var ModuleReference = this;
            textSize = 100;
            ModuleReference.ChangeTextSize(0);
        },

        SaveTextSize: function (size) {
            if (typeof (Storage) !== "undefined") {
                localStorage.setItem("incrementCount", parseInt(size) || 0);
            }
        },

        ChangeTextSize: function (increment) {
            textSize = textSize === 0 ? (100 + increment) : (textSize + increment);
            var ModuleReference = this;
            ModuleReference.SaveTextSize((textSize - 100) / 10);
            $(".section, .pullout-content").each(function () {
                $(this).css({ "font-size": textSize + "%" });
            });
            $(".textSizeIndicator").text(textSize + '%');
        },

        ObfuscateEmails: function () {
            var elementsToObfuscate = $(".email-obfuscate");
            elementsToObfuscate.each(function () {
                var emailStart = $(this).data("email-start");
                var emailAt = $(this).data("email-at");
                var setText = Boolean($(this).data("set-text"));

                $(this).attr("href", "mailto:" + emailStart + "@" + emailAt);
                if (setText)
                    $(this).text(emailStart + "@" + emailAt);
            });
        },

        InitMap: function () {
            $(".view-toggles .btn-map").on('click touchend', function () {
                ShowCategoriesMap();
            });
            function ShowCategoriesMap() {
                var mapContainer = $("#search-map");

                // Check that the map isn't already initialised
                if (mapContainer.length !== 0 && !mapContainer[0].firstChild) {
                    var location = new google.maps.LatLng(-27.4679, 153.0278);

                    var MY_MAPTYPE_ID = 'custom_style';

                    var featureOpts = [
                    { "featureType": "water", "stylers": [{ "saturation": -63 }] },
                    { "featureType": "road", "stylers": [{ "saturation": -100 }] },
                    { "featureType": "administrative.province", "elementType": "labels.text", "stylers": [{ "hue": "#dd00ff" }, { "weight": 1.2 }] },
                    { "featureType": "poi.government", "stylers": [{ "saturation": -100 }] },
                    { "featureType": "poi.business", "stylers": [{ "saturation": -100 }] },
                    { "featureType": "poi.government", "stylers": [{ "saturation": -100 }] },
                    { "featureType": "poi.medical", "stylers": [{ "saturation": -100 }] },
                    { "featureType": "poi.place_of_worship", "stylers": [{ "saturation": -100 }] },
                    { "featureType": "poi.school", "stylers": [{ "saturation": -100 }] },
                    { "featureType": "poi.sports_complex", "stylers": [{ "saturation": -100 }] },
                    { "featureType": "water", "stylers": [{ "saturation": 44 }] },
                    { "featureType": "administrative.locality" }
                    ];

                    var mapOptions = {
                        zoom: 12,
                        center: location,
                        mapTypeControlOptions: {
                            mapTypeIds: [google.maps.MapTypeId.ROADMAP, MY_MAPTYPE_ID]
                        },
                        mapTypeId: MY_MAPTYPE_ID
                    };

                    window.MapView = new google.maps.Map(mapContainer[0], mapOptions);

                    var styledMapOptions = { name: 'Custom Style' };

                    var customMapType = new google.maps.StyledMapType(featureOpts, styledMapOptions);
                    window.MapView.mapTypes.set(MY_MAPTYPE_ID, customMapType);
                }
                else {
                    // If the map has already been loaded, trigger a resize event so that the map loads correctly.
                    // This prevents a bug which caused the map to load incorrectly after the map had loaded then the browser size is changed.
                    google.maps.event.trigger(window.MapView, 'resize');
                }
            }
        },

        InitAutoComplete: function () {
            var siteParam = "";
            if (window.AppSettings.AffiliateSiteID) {
                siteParam = "?site=" + window.AppSettings.AffiliateSiteID;
            }

            var q = "";

            // This is an example of how the autocomplete functionality could be acheived using an external json file. 
            // For documentation on other methods, see this page: http://twitter.github.io/typeahead.js/examples/
            var locations = new Bloodhound({
                datumTokenizer: Bloodhound.tokenizers.obj.whitespace('name'),
                queryTokenizer: Bloodhound.tokenizers.whitespace,
                limit: 10,
                remote: {
                    url: window.AppSettings.ApiUrl + "/api/v1/system/localities/search",
                    replace: function (url, query) {
                        q = query;
                        // Change the url target url so it triggers
                        url = url + '#' + encodeURIComponent(q);
                        return url;
                    },
                    ajax: {
                        beforeSend: function (ev, settings) {
                            settings.data = JSON.stringify({ SearchTerm: q, Site: siteParam });
                            showSpinner('#autocomplete-location');
                        },
                        complete: function () { removeSpinner('#autocomplete-location'); },
                        dataType: "json",
                        contentType: "application/json; charset=utf-8",
                        type: "POST"
                    },
                    filter: function (results) {
                        if (results.success) {
                            return $.map(results.data, function (result) {
                                return {
                                    Name: result.Name,
                                    LocalityID: result.LocalityID
                                };
                            });
                        }

                        return null;
                    }
                }
            });

            var councils = new Bloodhound({
                datumTokenizer: Bloodhound.tokenizers.obj.whitespace('DisplayName'),
                queryTokenizer: Bloodhound.tokenizers.whitespace,
                limit: 10,
                remote: {
                    url: window.AppSettings.ApiUrl + "/api/v1/system/councils/search/%QUERY" + siteParam,
                    ajax: {
                        beforeSend: function () { showSpinner('#autocomplete-council, #autocomplete-council-mobile'); },
                        complete: function () { removeSpinner('#autocomplete-council, #autocomplete-council-mobile'); }
                    }
                }
            });

            // kicks off the loading/processing of `local` and `prefetch`
            locations.initialize();
            councils.initialize();

            // passing in `null` for the `options` arguments will result in the default
            // options being used

            // Locations
            //$('.where-field').typeahead({
            //    hint: true,
            //    minLength: 2,
            //    highlight: true
            //}, {
            //    name: 'locations',
            //    displayKey: 'Name',
            //    source: locations.ttAdapter(),
            //    templates: {
            //        suggestion: function (d) {
            //            return "<p class='needsclick'>" + d.Name + "</p>";
            //        }
            //    }
            //});

            //$('.where-field').bind('typeahead:change', function () {
            //    $("#SearchCriteria_LocationID").val('0');
            //    $("#SearchCriteria_CouncilID").val('0');
            //});
            //$('.where-field').on('typeahead:selected typeahead:autocompleted', function (obj, datum, name) {
            //    $("#SearchCriteria_LocationID").val(datum.LocalityID);
            //    $("#SearchCriteria_CouncilID").val(datum.CouncilID);
            //});

            $(".datepicker").datetimepicker({
                format: "D/MM/YYYY",
                locale: "en-AU",
                useCurrent: true,   
                showTodayButton: true
            });

            $("#SearchCriteria_SearchFrom").on("dp.change", function (e) {
                $("#SearchCriteria_SearchTo").data("DateTimePicker").minDate(e.date);
            });
            $("#SearchCriteria_SearchTo").on("dp.change", function (e) {
                $('#SearchCriteria_SearchFrom').data("DateTimePicker").maxDate(e.date);
            });

            // Locations
            locationTypeahead(".location-filter", locations);
            locationTypeahead("#location-request", locations);

            // Councils 
            $('#autocomplete-council, #autocomplete-council-mobile').typeahead({
                hint: true,
                minLength: 2,
                highlight: true
            }, {
                name: 'councils',
                displayKey: 'DisplayName',
                source: councils.ttAdapter(),
                templates: {
                    suggestion: function (d) {
                        return "<p class='needsclick'>" + d.DisplayName + "</p>";
                    }
                }
            });
            $('#autocomplete-council, #autocomplete-council-mobile').bind('typeahead:selected', function (obj, datum, name) {
                $.ajax({
                    url: "/StoreSearchedModelInSession",
                    type: "POST",
                    contentType: "application/json",
                    dataType: "json",
                    data: null,
                    error: function (result) {
                        console.log("fail: ", result);
                    },
                    success: function (result) {
                        console.log("victory")
                    },
                })
                window.location = datum.Url;
            });

            // Search On Press Enter
            $(document).ready(function () {
                $('#autocomplete-location-new').bind("keypress", function (e) {
                    if (e.keyCode == 13) {
                        return false;
                    }
                });
            });  
        },

        InitCouncilSearch: function () {
            $(".council-trail").on("click", ".regionfilter", function () {
                $("#councilModal").modal("show");
                $("#autocomplete-council").focus();
            });

            var hideSelector = getCookie("hide-council-selector");
            $('#setCouncilHide').prop('checked', hideSelector !== 'true');

            $("#setCouncilHide").on("click", function () {
                setCookie("hide-council-selector", !$("#setCouncilHide").is(":checked"), 365);
            });

            $("#locateMeHome").click(function (e) {
                e.preventDefault();
                PageSetup.GeolocateCouncil();
                $("#councilModal").modal('hide');
                requestedLocation = true;
            })

            $("#getMyCouncil").on("click", function (e) {
                navigator.geolocation.getCurrentPosition(findCouncilLocation, function (posError) {
                    handleNoGeolocation("We were unable to get your location from your browser for the following reason: <i>" + posError.message + "</i>");
                });
            });

            $("#locateMe").on("click", function (e) {
                e.preventDefault();
                PageSetup.GeolocateCouncil();
                $("#councilModal").modal('hide');
                requestedLocation = true;
            });
        },

        SendMail: function () {

            var email = { To: arguments[0], Subject: arguments[1], Body: arguments[2] };

            $.ajax({
                type: 'POST',
                url: "/api/Email/Send",
                data: JSON.stringify(email),
                contentType: 'application/json; charset=utf-8',
                dataType: 'json',
                success: function (data) { alert(data); },
                error: function () { alert('Failed'); }
            });
        },

        InitSearchResultsBehavior: function () {
            setupTooltipsStyling();

            $("a.phone").each(function () {
                $(this).attr("href", "tel:" + $(this).data("phone")
                    .replace(/ /g, "")
                    .replace(/\(/g, "")
                    .replace(/\)/g, ""));
            });
        },

        SetCookie: function (cname, cvalue, exdays) {
            setCookie(cname, cvalue, exdays);
        },

        GetCookie: function (cname) {
            return getCookie(cname);
        },

        SetupLocationNag: function () {
            setupLocationNag();
        }
    };

})();


